import $http from '../utils/http'

const requestTest = params => {
  // console.log(params)
  return $http({
    url: 'hello/test',
    params
  })
}

export default {
    requestTest
}
